import MainConnector from './MainConnector'
import { InsiPatient, LpsInfos } from './_types'

class INSIServerConnector extends MainConnector {
    insiUrl: string

    lpsInfos: LpsInfos | undefined

    patient: InsiPatient | undefined

    insiEsId : string | undefined

    constructor(
        insiUrl: string,
        verbose = false,
        testEnv = false,
    ) {
        super(verbose, testEnv)
        this.insiUrl = insiUrl
    }

    setPatient(patient : InsiPatient) {
        this.patient = patient
    }

    setInsiEsId(insiEsId : string) {
        this.insiEsId = insiEsId
    }

    setLpsInfos(lpsInfos : LpsInfos) {
        this.lpsInfos = lpsInfos
    }

    async checkInsIdentity(): Promise<any> {
        if (!this.patient) throw new Error('[INSIServerConnector-checkInsIdentity] Please give a valid PatientInsi object')
        if (!this.lpsInfos) throw new Error('[INSIServerConnector-checkInsIdentity] Please give a valid LpsInfos object')
        if (!this.insiEsId) throw new Error('[INSIServerConnector-checkInsIdentity] Please give a valid insiEsId')

        const requestEndPoint = 'checkInsIdentity'
        const extraEndPointParams = {
            LpsInfos: this.lpsInfos,
            s_insiEsId: this.insiEsId,
            s_insiUrl: this.insiUrl,
            s_birthName: this.patient.s_birthName,
            s_given: this.patient.s_given,
            i_sex: this.patient.i_sex,
            s_birthDate: this.patient.s_birthDate,
            s_birthPlace: this.patient.s_birthPlace,
            s_key: this.patient.s_key,
            s_oid: this.patient.s_oid,
            s_ins: this.patient.s_ins,
        }
        const result = await this.makeRequest(requestEndPoint, extraEndPointParams)
        return result
    }
}

export default INSIServerConnector
